import { useFormikContext } from 'formik';
import { Card } from '../../../../card/Card';
import {
  OBJECTS_BATCH_ERROR_MODES,
  PIPELINE_BATCH_ERROR_MODES
} from '../../constants/pipeline-settings';
import {
  PipelineConfigModeOption,
  PipelineSettingsFormFields,
  PipelineSettingsFormState
} from '../../interfaces/pipeline-settings-form-state';
import { PipelineTransactionalFailureAction } from '../../../../shared/interfaces/integration';
import { Autocomplete } from '../../../../input/Autocomplete/Autocomplete';
import styles from './PipelineFailureHandlingPolicyField.module.scss';
import { useAnalyticsTracker } from '../../../../tracking/hooks/useAnalyticsTracker';
import { PipelineSettingsTrackers } from '../../../tracking/pipeline-settings-trackers';
import { PipelineConfigRadioGroupWrapper } from '../PipelineConfigRadioGroupWrapper/PipelineConfigRadioGroupWrapper';

export function PipelineFailureHandlingPolicyField({ disabled }: { disabled?: boolean }) {
  const formikProps = useFormikContext<PipelineSettingsFormState>();
  const { eventTrack } = useAnalyticsTracker();

  const selectedErrorMode = formikProps.values[PipelineSettingsFormFields.ERROR_MODE];
  const objectErrorMode = formikProps.values[PipelineSettingsFormFields.OBJECT_LEVEL_ERROR_MODE];
  const objectErrorModeOption = OBJECTS_BATCH_ERROR_MODES.find(
    option => option.value === objectErrorMode
  );

  const modes = PIPELINE_BATCH_ERROR_MODES.filter(mode => !mode.isComingSoon);

  if (
    modes.length < 1 ||
    (modes.length === 1 && modes[0].value !== PipelineTransactionalFailureAction.PARTIAL)
  ) {
    return null;
  }

  return (
    <Card
      gridColumns={1}
      className='mt-5'
      title='Failure Handling Policy'
      dataId='failure-handling'
    >
      <PipelineConfigRadioGroupWrapper
        name={PipelineSettingsFormFields.ERROR_MODE}
        id='pipeline-error-mode'
        defaultValue={selectedErrorMode}
        currentValue={selectedErrorMode}
        className='grid-column-span-1'
        row={false}
        configModes={modes}
        onChange={async mode => {
          eventTrack({
            action: PipelineSettingsTrackers.PIPELINE_TRACKER_PIPELINE_SETTINGS_ERROR_MODE_CHANGE,
            properties: {
              mode
            }
          });

          await formikProps.setFieldValue(PipelineSettingsFormFields.ERROR_MODE, mode);
        }}
        disabled={disabled}
      />

      {selectedErrorMode === PipelineTransactionalFailureAction.PARTIAL ? (
        <Autocomplete
          dataId='object-failure'
          value={objectErrorModeOption}
          onChange={async (_, value) => {
            await formikProps.setFieldValue(
              PipelineSettingsFormFields.OBJECT_LEVEL_ERROR_MODE,
              (value as PipelineConfigModeOption).value
            );
          }}
          textFieldProps={{ placeholder: 'Object Level Settings', label: 'Object Level Settings' }}
          options={OBJECTS_BATCH_ERROR_MODES}
          disableClearable
          className={styles.objectErrorMode}
          style={{ width: '370px' }}
          disabled={disabled}
        />
      ) : null}
    </Card>
  );
}
